// @flow
import Immutable from "seamless-immutable";

export default () => Immutable({
	__record: "ImageSearchRecord",
	searchTerm: "",
	searchDone: false,
	firstSearch: true,
	progressIndicator: false,
	filtersDisplay: true,
	searchRight: "",
	searchRightIndex: -1,
	searchSite: "",
	searchSiteIndex: 0,
	showOptions: false,
	images: [],
	selected: [],
	lastSelectedIndex: -1,
	queries: null,
	searchError: null,
});
